import { getCollectionsQueryOptions } from '@/core/components/collections/collectionQueryOptions'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { NotFound } from '@/core/components/NotFound'
import { organizationQueryOptions } from '@/core/components/organizations/organizationQueryOptions'
import {
  getGroupsQueryOptions,
  propertiesQueryOptions,
} from '@/core/components/sites/propertyQueryOptions'
import { getCountriesQueryOptions } from '@/core/hooks/useGeo'
import { defer, redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const sitesSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
  sortBy: z.enum(['name', 'group', 'organization']).catch('name'),
  orderBy: z.enum(['asc', 'desc']).catch('desc'),
  organizationsId: z.string().catch('All'),
  tab: z.enum(['groups', 'properties', 'collections']).catch('properties'),
})

export const Route = createFileRoute('/_layout/dashboard/sites/')({
  validateSearch: (search) => sitesSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
  },
  loaderDeps: ({ search: { organizationsId } }) => ({ organizationsId }),
  loader: ({ context: { auth, queryClient }, deps: { organizationsId } }) => {
    const properties = queryClient.ensureQueryData(
      propertiesQueryOptions(auth.token!, organizationsId)
    )
    const groups = queryClient.ensureQueryData(
      getGroupsQueryOptions(auth.token!, organizationsId)
    )
    const collections = queryClient.ensureQueryData(
      getCollectionsQueryOptions(auth.token!, organizationsId)
    )
    const organizations = defer(
      queryClient.ensureQueryData(organizationQueryOptions(auth.token!))
    )

    const countries = queryClient.ensureQueryData(getCountriesQueryOptions())

    return { properties, organizations, groups, collections, countries }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
  notFoundComponent: () => <NotFound />,
})
